import { Box, Button, Container, Divider, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { deleteEmployeeAction, getEmployeesAction } from './APIs/action';
import EmployeeDetailCard from './Component/EmployeeDetailCard';
import { useNavigate } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EmployeeDetails = () => {
  const naviagte = useNavigate();
  const [employeeList, setEmployeeList] = useState([]);

  const getEmployees = async () => {
    const { data, error, message } = await getEmployeesAction();

    if (!error) {
      if (data.length > 0) {
        setEmployeeList(
          data.map((emp) => {
            return {
              ...emp,
              employee_roles: emp.permissions.map((role) => ({
                label: role.permission_name,
                value: role.permission_id,
              })),
            };
          }),
        );
      } else setEmployeeList([]);
    } else {
      return toast.error(message);
    }
  };
  useEffect(() => {
    getEmployees();
  }, []);
  const onDelete = async (values) => {
    const { error, message, data } = await deleteEmployeeAction({
      company_id: values.firm_id,
      company_user_id: values.id,
    });

    if (!error) {
      toast.success('Employee Deleted Successfully');
      getEmployees();
    } else {
      return toast.error(message);
    }
  };

  return (
    <Container
      maxWidth='true'
      sx={{ pl: '2rem', pt: '5rem' }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='h4'>Staff Details</Typography>
        <Button
          variant='outlined'
          color='primary'
          onClick={() => naviagte('/my-account/firm-details/add')}
        >
          Add Employee
        </Button>
      </Box>
      <Divider sx={{ mt: '1rem', mb: '3rem' }} />
      {employeeList &&
        employeeList.length > 0 &&
        employeeList.map((employee, index) => {
          return (
            <>
              <EmployeeDetailCard
                key={index}
                data={employee}
                onDelete={onDelete}
              />
              <Box sx={{ mt: 1 }} />
            </>
          );
        })}
    </Container>
  );
};

export default EmployeeDetails;
